import { render, staticRenderFns } from "./CurationRow.vue?vue&type=template&id=c266557c&scoped=true&"
import script from "./CurationRow.vue?vue&type=script&lang=js&"
export * from "./CurationRow.vue?vue&type=script&lang=js&"
import style0 from "./CurationRow.vue?vue&type=style&index=0&id=c266557c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c266557c",
  null
  
)

export default component.exports